import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { settings } from "@/mocks/siteData";
import { images } from "@/mocks/images";

export default function SettingPreview() {
  const preview = settings.slice(0, 3);
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="店铺设定"
          title="那间杂货铺到底藏着什么"
          desc="店铺本体、墙上的洞、店主的规矩、深夜的访客，以及村庄流传百年的秘密——设定大全带你逐一看清。"
        />
        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {preview.map((s) => (
            <article
              key={s.id}
              className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-colors hover:border-accent-300"
            >
              <div className="relative aspect-[3/2] w-full overflow-hidden bg-background-200">
                <img
                  src={images[s.imgSeq]}
                  alt={s.title}
                  title={`洞洞杂货铺 ${s.title}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
                  {s.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.summary}</p>
              </div>
            </article>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/settings"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600"
          >
            查看全部店铺设定
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}